import type { IFilter } from '@models/Filter'
import { endOfDay, startOfDay } from '@util/date-util'

import { apiClient } from '../../gateways/api'
import type { OpdrachtenSearch } from '../types/OpdrachtenSearch'

export { initialState, createFilters, searchOpdrachten }

const initialState: OpdrachtenSearch = {
  data: { count: 0, skip: 0, limit: 25, items: [] },
  query: {
    filters: {
      gebied: [],
      netbeheerder: null,
      aannemer: null,
      discipline: null,
      search: '',
      searchOption: null,
      versieNummer: null,
      open: true,
      creatiedatum: null,
      changed: null,
      werkbak: null,
    },
    sort: { sortBy: 'changed', sortDirection: 'desc' },
    page: { skip: 0, limit: 25 },
  },
}

const createFilters = ({
  discipline,
  netbeheerder,
  aannemer,
  gebied,
  versieNummer,
  open,
  creatiedatum,
  changed,
  search,
  searchOption,
  werkbak,
}) => {
  const filters: IFilter[] = []

  if (discipline)
    filters.push({ name: 'discipline', value: discipline.code, operator: 'eq' })
  if (netbeheerder)
    filters.push({ name: 'netbeheerder', value: netbeheerder, operator: 'eq' })
  if (aannemer)
    filters.push({ name: 'aannemer', value: aannemer, operator: 'eq' })
  if (gebied && gebied.length > 0)
    filters.push({
      name: 'details.combi.gebiedscode',
      value: gebied.map((x) => x.code),
      operator: 'in',
    })
  if (versieNummer)
    filters.push({ name: 'versieNummer', value: versieNummer, operator: 'eq' })
  if (open) filters.push({ name: 'status', value: 900, operator: 'lt' })
  if (werkbak)
    filters.push({ name: 'werkbak', value: werkbak.code, operator: 'eq' })

  if (creatiedatum) {
    filters.push({
      name: 'creatiedatum',
      value: startOfDay(creatiedatum),
      operator: 'gte',
    })
    filters.push({
      name: 'creatiedatum',
      value: endOfDay(creatiedatum),
      operator: 'lte',
    })
  }

  if (changed) {
    filters.push({
      name: 'changed',
      value: startOfDay(changed),
      operator: 'gte',
    })
    filters.push({ name: 'changed', value: endOfDay(changed), operator: 'lte' })
  }

  if (search && search !== '') {
    if (searchOption)
      filters.push({ name: searchOption.k, value: search, operator: 'eq' })
    else filters.push({ name: 'text', value: search, operator: 'contains' })
  }

  return filters
}

const searchOpdrachten = async ({
  query,
}: {
  query: OpdrachtenSearch['query']
}): Promise<OpdrachtenSearch['data']> => {
  const { filters, page, sort } = query

  const { data } = await apiClient({
    url: '/rest/opdracht/deelnemer',
    method: 'POST',
    data: { filters: createFilters(filters), ...page, ...sort },
  })

  return data
}
